<!-- media-viewer.component.html -->
<div class="viewer">
  <button mat-icon-button class="close" (click)="close()">
    <div class="close">&times;</div>
  </button>

  <div class="stage">
    <ng-container [ngSwitch]="currentFile?.type">
      <img *ngSwitchCase="'image'" [src]="currentFile.path || currentFile.file" class="media" appHideMissing>
      <video *ngSwitchCase="'video'" [src]="currentFile.path || currentFile.file" controls autoplay class="media" appHideMissing></video>
      <audio *ngSwitchCase="'audio'" [src]="currentFile.path || currentFile.file" controls autoplay class="media" appHideMissing></audio>
      <!-- <iframe *ngSwitchCase="'pdf'" [src]="currentFile.path || currentFile.file" class="media"></iframe>-->
      <!--<div *ngSwitchDefault class="media unsupported">
        <mat-icon>insert_drive_file</mat-icon>
        <p>Unsupported file</p>
      </div>-->
    </ng-container>

    <button *ngIf="files?.length > 1" mat-icon-button class="nav prev" (click)="prev()">
      <mat-icon>chevron_left</mat-icon>
    </button>
    <button *ngIf="files?.length > 1" mat-icon-button class="nav next" (click)="next()">
      <mat-icon>chevron_right</mat-icon>
    </button>
  </div>

  <!-- Thumbnails -->
  <div class="thumb-strip" *ngIf="files?.length > 1">
    <div *ngFor="let file of files; let i = index"
         [class.active]="i === index"
         (click)="select(i)">
      <img [class.active]="i === index" class="thumb" *ngIf="file.type === 'image'" [src]="file.path || file.file" (error)="removeFile(i)">
      <mat-icon [class.active]="i === index" class="thumb" *ngIf="file.type === 'video'">movie</mat-icon>
      <mat-icon [class.active]="i === index" class="thumb" *ngIf="file.type === 'audio'">audiotrack</mat-icon>
      <!--<mat-icon *ngIf="file.type === 'pdf'">picture_as_pdf</mat-icon>
      <mat-icon *ngIf="file.type === 'other'">insert_drive_file</mat-icon>-->
    </div>
  </div>
</div>
